import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useAtom } from 'jotai';
import React, { useState } from 'react';
import { Dimensions, ScrollView } from 'react-native';
import styled from 'styled-components/native';
import { SccButton } from '@/components/atoms';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import BottomSheet from '@/modals/BottomSheet';
import ChipSelector from '@/screens/SearchScreen/modals/ChipSelector';
import ScoreSelector from '@/screens/SearchScreen/modals/ScoreSelector.tsx';
const { height } = Dimensions.get('window');
export default function PlaceListFilterModal({ filterAtom, modalStateAtom, }) {
    const [savedFilter, setSavedFilter] = useAtom(filterAtom);
    const [state, setFilterModalState] = useAtom(modalStateAtom);
    const [draftSortOption, setDraftSortOption] = useState();
    const [draftHasSlope, setDraftHasSlope] = useState();
    const [draftScoreUnder, setDraftScoreUnder] = useState();
    const [draftIsRegistered, setDraftIsRegistered] = useState();
    const sortOption = draftSortOption === undefined ? savedFilter.sortOption : draftSortOption;
    const hasSlope = draftHasSlope === undefined ? savedFilter.hasSlope : draftHasSlope;
    const scoreUnder = draftScoreUnder === undefined ? savedFilter.scoreUnder : draftScoreUnder;
    const isRegistered = draftIsRegistered === undefined
        ? savedFilter.isRegistered
        : draftIsRegistered;
    const saveFilter = () => {
        setSavedFilter({
            sortOption,
            hasSlope,
            scoreUnder,
            isRegistered,
        });
        setFilterModalState(null);
    };
    const reset = () => {
        setDraftSortOption(undefined);
        setDraftHasSlope(undefined);
        setDraftScoreUnder(undefined);
        setDraftIsRegistered(undefined);
        setSavedFilter({
            sortOption: null,
            scoreUnder: null,
            hasSlope: null,
            isRegistered: null,
        });
    };
    return (_jsxs(BottomSheet, { isVisible: state !== null, onPressBackground: () => {
            setFilterModalState(null);
        }, children: [_jsxs(ScrollView, { bounces: false, style: {
                    maxHeight: (height * 80) / 100,
                }, contentContainerStyle: {
                    gap: 36,
                    paddingVertical: 24,
                    paddingHorizontal: 20,
                }, showsVerticalScrollIndicator: false, children: [(state === 'All' || state === 'sortOption') && (_jsxs(FilterItem, { children: [_jsx(FilterLabel, { children: "\uC815\uB82C" }), _jsx(ChipSelector, { items: [
                                    {
                                        label: '가까운 순',
                                        option: 'distance',
                                        isSelected: sortOption === 'distance',
                                    },
                                    {
                                        label: '접근레벨 낮은 순',
                                        option: 'accessibility_score',
                                        isSelected: sortOption === 'accessibility_score',
                                    },
                                ], onPress: option => {
                                    setDraftSortOption(option);
                                } })] })), (state === 'All' || state === 'scoreUnder') && (_jsxs(FilterItem, { children: [_jsx(FilterLabel, { children: "\uC811\uADFC\uB808\uBCA8" }), _jsx(ScoreSelector, { score: scoreUnder, onChange: (score) => {
                                    setDraftScoreUnder(score);
                                } })] })), (state === 'All' || state === 'hasSlope') && (_jsxs(FilterItem, { children: [_jsx(FilterLabel, { children: "\uACBD\uC0AC\uB85C \uC720\uBB34" }), _jsx(ChipSelector, { items: [
                                    {
                                        label: '전체',
                                        option: null,
                                        isSelected: hasSlope === null,
                                    },
                                    {
                                        label: '경사로 있음',
                                        option: true,
                                        isSelected: hasSlope === true,
                                    },
                                    {
                                        label: '경사로 없음',
                                        option: false,
                                        isSelected: hasSlope === false,
                                    },
                                ], onPress: option => {
                                    setDraftHasSlope(option);
                                } })] })), (state === 'All' || state === 'isRegistered') && (_jsxs(FilterItem, { children: [_jsx(FilterLabel, { children: "\uC815\uBCF5 \uC5EC\uBD80" }), _jsx(ChipSelector, { items: [
                                    {
                                        label: '전체',
                                        option: null,
                                        isSelected: isRegistered === null,
                                    },
                                    {
                                        label: '정복완료만 보기',
                                        option: true,
                                        isSelected: isRegistered === true,
                                    },
                                    {
                                        label: '정복 안 된 곳만 보기',
                                        option: false,
                                        isSelected: isRegistered === false,
                                    },
                                ], onPress: option => {
                                    setDraftIsRegistered(option);
                                } })] }))] }), _jsx(Divider, {}), _jsxs(ButtonBox, { children: [state === 'All' && (_jsx(SccButton, { text: '초기화', textColor: "black", buttonColor: "white", borderColor: "gray20", fontFamily: font.pretendardMedium, style: { flexGrow: 0, paddingHorizontal: 20 }, onPress: () => {
                            reset();
                        }, elementName: "place_list_filter_reset" })), _jsx(SccButton, { text: '결과보기', textColor: "white", buttonColor: "brandColor", fontFamily: font.pretendardMedium, style: { flexGrow: 1 }, onPress: () => {
                            saveFilter();
                        }, elementName: "place_list_filter_apply" })] })] }));
}
const ButtonBox = styled.View `
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 10px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;
const FilterItem = styled.View `
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;
const FilterLabel = styled.Text `
  font-size: 16px;
  font-family: ${() => font.pretendardBold};
  color: ${() => color.black};
`;
const Divider = styled.View `
  width: 100%;
  height: 1px;
  background-color: ${() => color.gray20};
`;
